import script from "./AddBlog.vue?vue&type=script&setup=true&lang=js"
export * from "./AddBlog.vue?vue&type=script&setup=true&lang=js"

import "./AddBlog.vue?vue&type=style&index=0&id=5a58dddd&lang=css"

const __exports__ = script;

export default __exports__